import { type Theme } from '../../../../../theme';
import { type ButtonStyles } from '../button.types';

export const getSecondaryAltButton = (theme: Theme): ButtonStyles => ({
  base: {
    color: theme.button.secondary.label,
    backgroundColor: theme.button.secondaryAlt.default,
    border: `1px solid ${theme.palette.neutral.grey[300]}`,
    boxShadow:
      '0 1px 0 0 rgba(0, 0, 0, 0.02), 0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 -4px 4px 0 rgba(0, 0, 0, 0.02) inset',

    '&:hover': {
      backgroundColor: theme.button.secondaryAlt.hover,
      boxShadow:
        '0 -4px 4px 0 rgba(0, 0, 0, 0.02) inset, 0 1px 0 0 rgba(0, 0, 0, 0.02), 0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    },

    '&:active, &:focus:not(:focus-visible)': {
      background: theme.button.secondaryAlt.pressed,
      outline: 'none',
    },

    '&:focus': {
      outline: `2.5px solid ${theme.button.focused.default}`,
      background:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)',
      backgroundBlendMode: 'lighten',
      borderColor: theme.button.secondaryAlt.border,
    },
  },
  active: {},
  isLoading: {},
  disabled: {
    backgroundColor: theme.button.secondaryAlt.disabled,
    border: `1px solid ${theme.button.secondaryAlt.border}`,
    color: theme.button.disabled.label,
    cursor: 'not-allowed',
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: 'none',
    },
    '&:active, &:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none',
    },
    svg: {
      color: theme.button.disabled.label,
    },
  },
});
